var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"g-recaptcha w-100 d-flex align-items-center app-download-btn btn btn-success btn-rounded",staticStyle:{"font-size":"30px"},attrs:{"disabled":_vm.processing},on:{"click":_vm.handlePayment}},[(_vm.amount)?_c('span',[_vm._v(" Comprar BeCupon ")]):_c('span',[_vm._v(" Adquirir BeCupon ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }